import React from "react";
import { Box, Grid, Typography, Card, Container, useTheme, useMediaQuery } from "@mui/material";
import VideoPlayer from "../../components/common/VideoPlayer";
import { HeadingText } from "../../utils/CustomTagComponents";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const HowToOpen = ({ about_title, about_desc, videos = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  if (!videos.length) return null;

  const getResponsiveHtml = (html) => {
    if (!html) return "";
    if (!isMobile) return html.replace(/<br\s*\/?>/gi, "").replace(/&nbsp;/gi, " ").replace(/\u00A0/gi, " ").replace(/\[empty_line\]/gi, "<br />");

    return html
      .replace(/font-size:\s*\d+px/gi, "font-size: 18px")
      .replace(/font-weight:\s*900/gi, "font-weight: 700")
      .replace(/<br\s*\/?>/gi, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/\u00A0/gi, " ")
      .replace(/\[empty_line\]/gi, "<br />");
  };

  const getGridSize = (count) => {
    if (count === 1) return 12; // full width
    if (count === 2) return 6;  // 50%
    return 4;                  // 3 per row
  };

  const gridSize = getGridSize(videos.length);

  return (
    <Container sx={{
      py: { xs: 2, sm: 2, md: 3 },
      px: { xs: 3, sm: 4, md: 6 },
      paddingLeft: { xs: "24px !important", md: "48px !important" },
      paddingRight: { xs: "24px !important", md: "48px !important" }
    }}>
      <Box
        ref={ref}
        component={motion.div}
        variants={fadeUp}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        {/* Section Heading */}
        <HeadingText
          mb={1}
          dangerouslySetInnerHTML={{ __html: getResponsiveHtml(about_title) }}
        />

        {/* Videos */}
        <Grid container spacing={4}>
          {videos.map((mediaLink, index) => (
            <Grid
              component={motion.div}
              variants={fadeUp}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              transition={{ delay: index * 0.2 }}
              size={{ xs: 12, md: gridSize }} key={index}>
              <Card
                sx={{
                  borderRadius: 4,
                  overflow: "hidden",
                }}
              >
                <VideoPlayer
                  src={mediaLink}
                  width="100%"
                  height="100%"
                  iconSize={{ xs: 40, sm: 50, md: 60 }}
                />
              </Card>
            </Grid>
          ))}
        </Grid>
        {about_desc && (
          <Box
            sx={{
              borderRadius: "10px",
              mt: { xs: 2, md: 0 },
              width: { xs: "100%", md: "100%" },
              zIndex: 2,
              minHeight: { xs: "auto" }, // ✅ dynamic height
              display: "flex",
            }}
          >
            <Typography
              sx={{
                textAlign: "justify"
              }}
              dangerouslySetInnerHTML={{ __html: getResponsiveHtml(about_desc) }}
            />
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default HowToOpen;